module.exports = __webpack_public_path__ + "assets/process2.874b9983.svg";